import _ from 'underscore';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { withUiBlock } from '@bingads-webui/uiblocker';

export function inlineEditableSave({
  view,
  i18n,
  fieldName,
  updated,
  editorView,
  editorViewCallbackAfterUpdate,
  successCallback,
}) {
  const toUpdate = _.pick(updated, 'Id', fieldName);

  // TODO: Sync with MT about the format
  return TargetingSettingsContext.jsDataCampaign.Campaign
    .update(updated.Id, toUpdate, { adapter: 'bulk' })
    .finally(withUiBlock(view.grid.gridView.$el))
    .then(() => {
      if (editorViewCallbackAfterUpdate && _.isFunction(editorViewCallbackAfterUpdate)) {
        editorViewCallbackAfterUpdate();
      }
      if (_.isFunction(successCallback)) {
        successCallback(updated);
      }

      view.grid.gridView.trigger('didEdit', updated);
    })
    .catch((response) => {
      let error;
      const unexpectedError = i18n.getString('ErrorNumber_-1');

      if (!response || !response.errors) {
        error = unexpectedError;
      } else {
        const errors = TargetingSettingsContext.i18nErrors.getBulkApiErrors(response.errors);

        if (!errors || !errors[0] || !errors[0].message) {
          error = unexpectedError;
        } else {
          error = errors[0].message;
        }
      }

      if (editorView && editorView.$el.is(':visible') && _.isFunction(editorView.setErrors)) {
        editorView.setErrors({ [fieldName]: error });
      } else {
        const alertHelper = new AlertHelper({ i18n });
        alertHelper.showError(error);
      }
    });
}
